module.exports = __webpack_public_path__ + "img/5.2-运营效率低下.d2a271b5.png";